import { MAIN_MENU_AMPLITUDE_SOURCE_DETAIL_KEY } from '@crehana/web/dist/MainMenu/constants';

const removeMainMenuSourceDetail = ({ url }: { url: string }) =>
  url.replace(MAIN_MENU_AMPLITUDE_SOURCE_DETAIL_KEY, '');

export default removeMainMenuSourceDetail;
